// Notion 28 spec のモーダル共通 paper 装飾.
// MUI Dialog の default elevation は「ふわっ」した影で Notion の薄い 3 段影と異なるため、
// 全ダイアログでこの paper sx を `& .MuiDialog-paper` に当て、 角丸 + modal 影を統一する.
// (= 加算履歴 / 調剤鑑査 / 疑義照会 / 患者リンク共有 など ⋯ から開く全モーダルで SSoT 化.)
//
// 影は 28 spec §9.1 boxShadow.modal の literal (= colorTokens.shadow.modal と同値). 本 file は
// shared 層なので latest token へ依存させず canon 値を直接持つ.
import { RADIUS } from './radii'

export const NOTION_DIALOG_PAPER_SX = {
  borderRadius: `${RADIUS.xl}px`,
  boxShadow: '0 0 0 1px rgba(15,15,15,0.05), 0 12px 36px rgba(15,15,15,0.30)',
} as const

// dialog の中の複数行入力 (一括置換 / 改善依頼) の共通装飾.
// 罫線は Notion 流の半透明 3 段 (通常 / hover / focus). 文字は body2 参照で
// 文字サイズモード (ADR-0019) に追従させる — 入力欄だけ据え置くと「大」で読めない.
export const NOTION_DIALOG_TEXTFIELD_SX = {
  '& .MuiOutlinedInput-root': {
    fontSize: (theme: {
      typography: { body2: { fontSize?: string | number } }
    }) => theme.typography.body2.fontSize,
    borderRadius: `${RADIUS.md}px`,
    bgcolor: 'background.paper',
    '& fieldset': { borderColor: 'rgba(55,53,47,0.16)' },
    '&:hover fieldset': { borderColor: 'rgba(55,53,47,0.32)' },
    // focus の青は latest accent.primary と同値 (paper の影と同じく canon 値を直接持つ).
    '&.Mui-focused fieldset': { borderColor: '#2383E2', borderWidth: 1 },
  },
} as const
